import React from "react";
import { useSelector, useDispatch } from 'react-redux';
import { ThunkDispatch } from "@reduxjs/toolkit";
import TextInput from "../../../../components/TextInput";
import CustomIconButton from "../../../../components/CustomIconButton";
import MonthRangePicker from "../../../../components/MonthRangePicker";
import CheckboxButton from "../../../../components/CheckboxButton";
import { mypageActions } from "../../../../reducers/talentMypage";

const CareerSection = ({ 
    dataCareer, 
    setDataCareer, 
    setDisplay,
    validateCareer }: any) => {
    const { talent, errors } = useSelector((state: any) => state.talentMypage)
    const dispatch = useDispatch<ThunkDispatch<any, any, any>>()

    const removeCareerItem = (idx: any) => {
        const newDataCareer = dataCareer.filter((_, index) => index !== idx);
        setDataCareer(newDataCareer);
        const careerValidation = validateCareer(newDataCareer);
        dispatch(mypageActions.setErrors(errors => ({
            ...errors,
            career: careerValidation.error
        })));
    }

    const handleAddOtherCareer = () => {
        const newCareer = { id: null, talent_id: null, description: "", join_date: "", leave_date: "", is_current: false }
        setDataCareer((prevDataCareer) => [...prevDataCareer, newCareer]);
        setDisplay(true)
    }

    return (
        <>
            <div className="flex flex-wrap gap-4 items-center mb-2">
                <p className="alu-text-base-2 text-base font-bold">キャリア</p>
            </div>
            <div className="flex flex-col gap-2 mb-2">
                {(Array.isArray(dataCareer)) && dataCareer.map((item: any, idx: any) => (
                <div className="flex items-center justify-between gap-1" key={idx}>
                    <div className="flex-1 flex gap-1 rounded-[0.25rem] bg-[#F5F5F5] pt-2 pr-2 pb-1 pl-1">
                    <span className="shrink-0 pt-[0.375rem]">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <mask id="mask0_19572_32422" style={{maskType:"alpha"}} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                            <rect width="24" height="24" fill="#D9D9D9"/>
                        </mask>
                        <g mask="url(#mask0_19572_32422)">
                            <path d="M8 10C8 11.1 8.39167 12.0417 9.175 12.825C9.95833 13.6083 10.9 14 12 14C13.1 14 14.0417 13.6083 14.825 12.825C15.6083 12.0417 16 11.1 16 10C16 8.9 15.6083 7.95833 14.825 7.175C14.0417 6.39167 13.1 6 12 6C10.9 6 9.95833 6.39167 9.175 7.175C8.39167 7.95833 8 8.9 8 10ZM6 10C6 8.33333 6.58333 6.91667 7.75 5.75C8.91667 4.58333 10.3333 4 12 4C13.6667 4 15.0833 4.58333 16.25 5.75C17.4167 6.91667 18 8.33333 18 10C18 11.5 17.525 12.8042 16.575 13.9125C15.625 15.0208 14.4333 15.6917 13 15.925C13 15.925 12.3905 16 12 16C11.6095 16 11 15.925 11 15.925C9.56667 15.6917 8.375 15.0208 7.425 13.9125C6.475 12.8042 6 11.5 6 10Z" fill="#808080"/>
                            <path d="M11 17H13V19H11V17Z" fill="#808080"/>
                            <path d="M11 20H13V22H11V20Z" fill="#808080"/>
                        </g>
                        </svg>
                    </span>
                    <div className="w-full flex flex-col gap-2">
                        <TextInput
                        size="md"
                        name="career[description][]"
                        placeholder="職場"
                        value={item.description}
                        onChange={(e:any) => {
                            setDataCareer((prev) => prev.map((careerItem, careerIdx) =>
                            careerIdx === idx
                                ? { ...careerItem, description: e.target.value }
                                : careerItem
                            ))
                            setDisplay(true)
                        }
                        }
                        />
                        <div className="w-full">
                        <MonthRangePicker
                            type={3}
                            startMonth={item.join_date}
                            endMonth={item?.leave_date ? item?.leave_date : ''}
                            onChange={(start: string, end: string) => {
                            setDataCareer((prev) => prev.map((careerItem, careerIdx) =>
                                careerIdx === idx
                                ? { ...careerItem, join_date: start, leave_date: end }
                                : careerItem
                            ))
                            setDisplay(true)
                            }}
                        />
                        </div>
                        <div className="flex gap-2 items-center">
                        <CheckboxButton
                            id={"careerChecked" + idx}
                            name="career[checked][]"
                            value={item.is_current}
                            label={"現職"}
                            onChange={(e:any) => {
                            let leaveDateToCurrent;
                            setDataCareer((prev) =>
                                prev.map((careerItem, careerIdx) =>{
                                    if(careerIdx === idx) {
                                    leaveDateToCurrent = !careerItem.is_current;
                                    return {
                                        ...careerItem,
                                        is_current: !careerItem.is_current,
                                    }
                                    } else return careerItem
                                }
                                )
                            );
                            setDisplay(true)
                            }
                            }
                        />
                        </div>
                    </div>
                    </div>
                    <CustomIconButton
                    customStyle="shrink-0"
                    onClick={() => removeCareerItem(idx)}
                    >
                    <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill="currentColor"><path d="M200-440v-80h560v80H200Z"/></svg>
                    </CustomIconButton>
                </div>
                ))}
            </div>
            {errors && errors?.career && <p className='alu-text-error text-sm mt-1 mb-3'>※{errors?.career}</p>}
            <div className="">
                <button type="button" className="flex items-center gap-1 p-1 hover:bg-[#FFF3E5] rounded" onClick={handleAddOtherCareer}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <g clipPath="url(#clip0_13284_8548)">
                    <path d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z" fill="#FF861A" />
                    </g>
                    <defs>
                    <clipPath id="clip0_13284_8548">
                        <rect width="24" height="24" fill="white" />
                    </clipPath>
                    </defs>
                </svg>
                <span className="alu-text-title text-sm">キャリアを追加する</span>
                </button>
            </div>
        </>
    )
};

export default CareerSection;